const SUGGESTED = 2;
const SAID_YES = 5;
const SAID_NO = 6;

export { SUGGESTED, SAID_YES, SAID_NO };
